$(document).ready(function(){
  

  //display popup US to foreign visitors
  var hours = 24; // Reset when storage is more than 24hours
  var now = new Date().getTime();
  var setupTime = localStorage.getItem('setupTime');
  var lang_code = "en";

  if(typeof langify !== "undefined"){
       lang_code = langify.locale.iso_code;
  }

  var isUSA = false;

  if (window.location.hostname.indexOf('us.gusti.ca') !== -1 || window.location.hostname.indexOf('gusti-us.myshopify.com') !== -1){
      isUSA = true;
  }

   if (setupTime == null) {
       localStorage.setItem('setupTime', now)
   } else {
       if(now - setupTime > hours*60*60*1000) {
           localStorage.removeItem('country_code');
           localStorage.setItem('setupTime', now);
       }
   }

   if (!localStorage.getItem('country_code') ){

       $.getJSON("https://get.geojs.io/v1/ip/country.json", function(json) {
           var ip_country_code = json.country;
           var popup_lang_key = false; //default
           localStorage.setItem('country_code', ip_country_code);
           //display popup if IP is in CAN but user is not on the CAN site
           if(ip_country_code == "CA" && isUSA){
              popup_lang_key = "en_ca";
           }

           if(ip_country_code == "US" && !isUSA){
              popup_lang_key = "en_us";
           }

           console.log(ip_country_code, isUSA, popup_lang_key);

           //if country is not matching, show popup
           if(popup_lang_key && $( "#country-popup" ).length){
               $.fancybox.open({
                  src  : '#country-popup',
                  type : 'inline',
                  opts : {
                      modal: true,
                      baseClass: popup_lang_key,
                      afterShow : function( instance, current ) {
                          
                      }
                  }
              });
           }
       });
   }

  if($(window).scrollTop() > 100){
  	$("#shopify-section-header").addClass("shopify-section-header-sticky")
  }
  if($("body").hasClass("template-product")){
    setTimeout(function(){
         $("html, body").animate({ scrollTop: 0 }, 600);
        }, 700)
  	
  }
  //for FAQ PAGE SCROLL
  const faqs_wrapper = $(".faqs-page");
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom ? $(this).attr("id") : ''; 
  };
  $(window).on('scroll', function() {
  	if(faqs_wrapper != "undefined"){
        var in_view = "";
        var faqs_in_view = [];
        $(".faqs-header").each(function(){
            if($(this).isInViewport()){
                
                in_view = $(this).attr("id");
                faqs_in_view.push(in_view);
                
            }
        });
      
        $("#sticky-sidebar li a button").removeClass("active");
        $(".sticky-"+faqs_in_view[0]).find("a button").addClass("active");
        if(($(window).innerHeight() + $(window).scrollTop()) >= $("body").height()){
            if($(window).height() > 1300){
                 $("#sticky-sidebar li a button").removeClass("active");
                $("#sticky-sidebar li:last-child a button").addClass("active");

            }
        }
    }
    if($(window).width() > 749){
      if($(".product-faq-index .only_sidebar").length > 0){
          var list_height = $("#MainContent").height();
          if($(window).scrollTop() > (list_height - 200)){
            $(".product-faq-index .only_sidebar").closest(".product-faq-index").removeClass("sticky--faq");
          }
          else{
            $(".product-faq-index .only_sidebar").closest(".product-faq-index").addClass("sticky--faq");
          }
       }
    }
    
    
    if($(window).scrollTop() > 35){
        $("#shopify-section-header").addClass("shopify-section-header-sticky")
      }
    
    if($("body").hasClass("template-collection")){
      if($(window).scrollTop() >= 90){
          $(".custom_filter_holder .facet_container").addClass("fixed--container");
      }
      else{
        $(".custom_filter_holder .facet_container").removeClass("fixed--container")
      }
    }
    else{
      if($(window).scrollTop() >= 310){
          $(".template-search .custom_filter_holder .facet_container").addClass("fixed--container");
      }
      else{
        $(".template-search .facet_container").removeClass("fixed--container")
      }
    }
    
    
    
  });
  if($(window).width() > 749){
    if($(".product-faq-index .only_sidebar").length > 0){
      $(".product-faq-index .only_sidebar").closest(".product-faq-index").addClass("sticky--faq");
    }
  }
  
  function shipping_bar(){
    if($(".free_shipping_holder").length > 0){
      $.ajax({
              type: 'GET',
              url: '/cart.js',
              dataType: 'json', 
              success: function (cart) {
                 var cartTotal = cart.total_price / 100;
                var free_shipping_amount = parseFloat($(".free_shipping_holder").attr("data-free-ship"));
                //console.log(free_shipping_amount)
                if(cart.item_count > 0){
                  var remainingFreeShippingAmount = free_shipping_amount - cartTotal,
                    freeShippingThreshold = cartTotal / free_shipping_amount * 100;
                  $(".free_shipping_holder").show()
                  if(cartTotal < free_shipping_amount) {
                    $(".left_shipping_target").text("$"+remainingFreeShippingAmount.toFixed(2))
                    $(".free-shipping-progress-bar").css("width", freeShippingThreshold+"%")
                    $(".free_shipping_holder .shipping_text_holder p").show();
                      $(".free_shipping_holder .shipping_text_holder p.shipping_success").hide();
                    //console.log(remainingFreeShippingAmount)
                   }    
                  else {
                    $(".free_shipping_holder .shipping_text_holder p").hide();
                      $(".free_shipping_holder .shipping_text_holder p.shipping_success").show();
                    $(".free-shipping-progress-bar").css("width", "100.5%")
                  }
                }
                else{
                  $(".free_shipping_holder").hide()
                  $(".cart-count-bubble").css("display","none");
                }
                
              }
      });
    }
  }
  shipping_bar();       
  
   function cartDrawer(){
  	$.ajax({
            type: 'GET',
            url: window.routes.root_url + 'cart.js',
            dataType: 'json', 
            success: function (cart) {
               for(var i =0; i < cart.items.length; i++){
                 var obj = "";
                 //console.log(cart.items[i].handle)
                 if(cart.items[i].variant_options[0] != "Default Title"){
                   obj += "<dl>";
                   for(j = 0; j < cart.items[i].options_with_values.length; j++){
                   		obj +=   '<div class="cart-notification-product__option h4"> <dt>'+cart.items[i].options_with_values[j].name+': </dt> <dd>'+cart.items[i].options_with_values[j].value.split("(")[0]+'</dd> </div>'
                   }
                   obj +=   '<div class="cart-notification-product__option h4"> <dt>'+window.cartStrings.quantity+': </dt> <dd>'+cart.items[i].quantity+'</dd> </div>'
                   
                  obj += "</dl>";
                 }
                 var prod_image = cart.items[i].image.replace(".jpg","_140x.jpg")
                 prod_image = prod_image.replace(".png","_140x.png")
                 if(i == 0 ){
//                  	$('.cart-notification-custom  #cart-notification-product').html('<div id="cart-notification-products '+cart.items[i].id+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+cart.items[i].image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold">'+cart.items[i].product_title +'</h3> <dl> <div class="cart-notification-product__option h4 p1_text"> '+cart.items[i].product_type+' </div> </dl> <div class="cart_bottom_holder"> <h3 class="p1_text bold"> $'+cart.items[i].original_line_price/100+' </h3><div class="cart_quantity p2_text ">Quantity: '+cart.items[i].quantity+' </div> <a href="/cart/change?id='+cart.items[i].variant_id+'&quantity=0" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
                   $('.cart-notification-custom  #cart-notification-product').html('<div id="cart-notification-products '+cart.items[i].id+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+prod_image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold" data-url="'+cart.items[i].url+'">'+cart.items[i].product_title +'</h3> '+obj+' <div class="cart_bottom_holder"> <div class="qty_heading_holder">  <h3 class="p1_text bold"> $'+(cart.items[i].original_line_price/100).toFixed(2)+' </h3> </div> <a class="remove_cart_drawer" data-line="'+cart.items[i].variant_id+'" href="javascript:;" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'"> ' + window.cartStrings.remove + ' </a> </div> </div> </div>');
                 }
                 else{
//                  $('.cart-notification-custom  #cart-notification-product').append('<div id="cart-notification-products '+cart.items[i].id+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+cart.items[i].image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold">'+cart.items[i].product_title +'</h3> <dl> <div class="cart-notification-product__option h4 p1_text"> '+cart.items[i].product_type+' </div> </dl> <div class="cart_bottom_holder"> <h3 class="p1_text bold"> $'+cart.items[i].original_line_price/100+' </h3><div class="cart_quantity p2_text ">Quantity: '+cart.items[i].quantity+' </div> <a href="/cart/change?id='+cart.items[i].variant_id+'&quantity=0" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
                   $('.cart-notification-custom  #cart-notification-product').append('<div id="cart-notification-products '+cart.items[i].id+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+prod_image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold" data-url="'+cart.items[i].url+'">'+cart.items[i].product_title +'</h3> '+obj+' <div class="cart_bottom_holder"><div class="qty_heading_holder"> <h3 class="p1_text bold"> $'+(cart.items[i].original_line_price/100).toFixed(2)+' </h3></div> <a class="remove_cart_drawer" data-line="'+cart.items[i].variant_id+'" href="javascript:;" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'"> ' + window.cartStrings.remove + ' </a> </div> </div> </div>');
                 }
               }
                  $("div#cart-notification-product").css("flex-direction","column");
                  $(".cart-notification-custom #cart-notification__links").html(window.cartStrings.viewBag)
                  $(".cart-notification-custom #cart-notification-button").html(window.cartStrings.viewBag)
                  $(".header__icons  .cart-count-bubble span").html(cart.item_count)
                  if(cart.items.length == 0){
                    $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","none")
                    $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","block")
                    $("#cart-notification-product").html("");
                    $(".cart-notification-custom").addClass("empty_cart_custom");
                     $(".header .cart-count-bubble").css("display" ,"none");
                     $(".free_shipping_holder").hide()
                  }
                  else{
                    $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","flex")
                    $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","none")
                    $(".cart-notification-custom").removeClass("empty_cart_custom");
                     $(".header .cart-count-bubble").css("display" ,"block");
                     $(".free_shipping_holder").show()
                  }
                  shipping_bar();
              	  $(".cart_subtotal_holder span.subtotal_price").html('$'+(cart.original_total_price/100).toFixed(2)+'');
                  $("#cart-notification").addClass("active");
            } 
        
     });
  }
  
  $(".custom_cart_icon").on("click",function(){
    if(window.location.pathname == "/cart"){
      window.location.reload();
    }
    else{
      $.ajax({
        type: 'GET',
        url: window.routes.root_url + 'cart.js',
        dataType: 'json', 
        success: function (cart) {
           for(var i =0; i < cart.items.length; i++){
             var obj = "";
           if(cart.items[i].variant_options[0] != "Default Title"){
             obj += "<dl>";
             for(j = 0; j < cart.items[i].options_with_values.length; j++){
                  obj +=   '<div class="cart-notification-product__option h4"> <dt>'+cart.items[i].options_with_values[j].name+': </dt> <dd>'+cart.items[i].options_with_values[j].value.split("(")[0]+'</dd> </div>'
             }
              obj +=   '<div class="cart-notification-product__option h4"> <dt>'+window.cartStrings.quantity+': </dt> <dd>'+cart.items[i].quantity+'</dd> </div>'
            obj += "</dl>";
           }
           var prod_image = cart.items[i].image.replace(".jpg","_140x.jpg")
                 prod_image = prod_image.replace(".png","_140x.png")
                 //console.log(cart.items[i].image.replace(".png","_140x.png"))
                 if(i == 0 ){
//                  	$('.cart-notification-custom  #cart-notification-product').html('<div id="cart-notification-products '+cart.items[i].id+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+cart.items[i].image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold">'+cart.items[i].product_title +'</h3> <dl> <div class="cart-notification-product__option h4 p1_text"> '+cart.items[i].product_type+' </div> </dl> <div class="cart_bottom_holder"> <h3 class="p1_text bold"> $'+cart.items[i].original_line_price/100+' </h3><div class="cart_quantity p2_text ">Quantity: '+cart.items[i].quantity+' </div> <a href="/cart/change?id='+cart.items[i].variant_id+'&quantity=0" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
                   $('.cart-notification-custom  #cart-notification-product').html('<div id="cart-notification-products '+cart.items[i].id+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+prod_image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold" data-url="'+cart.items[i].url+'">'+cart.items[i].product_title +'</h3> '+obj+' <div class="cart_bottom_holder"> <div class="qty_heading_holder">  <h3 class="p1_text bold"> $'+(cart.items[i].original_line_price/100).toFixed(2)+' </h3> </div> <a class="remove_cart_drawer" data-line="'+cart.items[i].variant_id+'" href="javascript:;" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'"> ' + window.cartStrings.remove + ' </a> </div> </div> </div>');
                 }
                 else{
//                  $('.cart-notification-custom  #cart-notification-product').append('<div id="cart-notification-products '+cart.items[i].id+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+cart.items[i].image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold">'+cart.items[i].product_title +'</h3> <dl> <div class="cart-notification-product__option h4 p1_text"> '+cart.items[i].product_type+' </div> </dl> <div class="cart_bottom_holder"> <h3 class="p1_text bold"> $'+cart.items[i].original_line_price/100+' </h3><div class="cart_quantity p2_text ">Quantity: '+cart.items[i].quantity+' </div> <a href="/cart/change?id='+cart.items[i].variant_id+'&quantity=0" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'">  remove </a> </div> </div> </div>');
                   $('.cart-notification-custom  #cart-notification-product').append('<div id="cart-notification-products '+cart.items[i].id+'" class="cart-notification-product"> <img class="cart-notification-product__image" src="'+prod_image+'" width="70" loading="lazy" > <div class="cart-notification-product__info"> <h3 class="cart-notification-product__name h4 p1_text bold" data-url="'+cart.items[i].url+'">'+cart.items[i].product_title +'</h3> '+obj+' <div class="cart_bottom_holder"><div class="qty_heading_holder"> <h3 class="p1_text bold"> $'+(cart.items[i].original_line_price/100).toFixed(2)+' </h3> </div> <a class="remove_cart_drawer" data-line="'+cart.items[i].variant_id+'" href="javascript:;" class="cart-notification-remove p2_text" data-id="'+cart.items[i].variant_id+'"> ' + window.cartStrings.remove + ' </a> </div> </div> </div>');
                 }
           }
             $("div#cart-notification-product").css("flex-direction","column");
          $(".cart-notification-custom #cart-notification__links").html(window.cartStrings.viewBag);
          $(".cart-notification-custom #cart-notification-button").html(window.cartStrings.viewBag);
          if(cart.items.length == 0){
            $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","none")
            $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","block")
            $(".cart-notification-custom").addClass("empty_cart_custom");
             $(".free_shipping_holder").hide()
          }
          else{
            $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","flex")
            $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","none")
            $(".cart-notification-custom").removeClass("empty_cart_custom");
             $(".free_shipping_holder").show()
          }
          shipping_bar();
          $(".cart_subtotal_holder span.subtotal_price").html('$'+(cart.original_total_price/100).toFixed(2)+'');
          $("#cart-notification").addClass("active");
        } 

       });
      }
    })
  
  
  
 $(".template-product .product-form__submit").on("click",function(event){
  	$("div#cart-notification-product").css("flex-direction","row");
    $(".cart-notification-custom").removeClass("empty_cart_custom");
    $(".cart-notification-custom .cart-notification__header .cart-notification__heading").css("display","flex");
    $(".cart-notification-custom .cart-notification__header .cart-notification__heading.empty_cart_head").css("display","none");
    //console.log("casr")
    event.preventDefault();
    $.ajax({
      type:"POST",
      url:"/cart/add.js",
      data:{id:$(this).closest("form").find("input[name='id']").val(),quantity:1},
      dataType:"json",
      async:false,
      success:function(cart){
        //console.log(cart)
        cartDrawer()
        setTimeout(function(){
         $("#cart-notification").removeClass("active");
        }, 4000)
      }
    });
    
  });
  $(".show_filters").on("click",function(event){
    if($(this).hasClass("activated")){
      $(this).closest(".collection-grid-section").find(".custom_filter_holder .facet_container").hide();
      $(this).closest(".collection-grid-section").find(".custom_filter_holder #CollectionProductGrid").removeClass("activated");
      $(this).removeClass("activated");
      if($(window).width() > 767 && $(window).width() < 1025 ){
//       	$("body.template-collection").css("overflow","unset");
      }
      $(this).find("span").html("Filter by")
    }
    else{
      $(this).closest(".collection-grid-section").find(".custom_filter_holder .facet_container").show();
      $(this).closest(".collection-grid-section").find(".custom_filter_holder #CollectionProductGrid").addClass("activated");
      $(this).addClass("activated");
      if($(window).width() > 767 && $(window).width() < 1025 ){
//       	$("body.template-collection").css("overflow","hidden");
      }
      $(this).find("span").html("Hide Filters")
    }
  });
  
  $(".template-collection  .facets__item label").on("change",function(event){
    if($(this).closest(".facet-checkbox").find("input").prop("checked")){
    	$(this).closest(".facet-checkbox").find("input").prop("checked",true)
    }
    else{
    	$(this).closest(".facet-checkbox").find("input").prop("checked",false)
    }
  });
  
  $(".custom_filter_holder form#FacetFiltersForm .facets__wrapper .icon-close").on("click",function(event){
  	$(".show_filters").click();
  });
  
  $(".custom_filter_holder .facets__summary").on("click",function(event){
    if($(this).hasClass("activated")){
    	$(this).removeClass("activated");
      $(this).next().slideUp();
    }
    else{
    	$(this).addClass("activated");
      $(this).next().slideDown();
    }
    
  });
  
  $("#menu-drawer .menu-drawer__inner-container .child--menu-list .child--menu-list-summary").on("click",function(event){
    if($(this).hasClass("active_menu")){
    	$(this).removeClass("active_menu");
      $(this).next().slideUp();
    }
    else{
    	$(this).addClass("active_menu");
      $(this).next().slideDown();
    }
    
  });
  $(".product-faqs .faqs-accordian").on("click", function(){
      console.log("TEST") 
      $(".product-faqs .faqs-accordian").not(this).find(".accordion-button").addClass("collapsed");
        $(".product-faqs .faqs-accordian").not(this).find(".accordion-collapse").removeClass("show");
    });
  
//   $(".faqs-opener").on("click", function(){
//         $(".faqs-opener").not(this).removeClass("open");
//         var current = this;
//         var id = $(this).attr("data-id");
//         $(".faqs-opener").each(function(){
//             if($(this).attr("data-id") != id){
//                 $(".faqs-type-"+$(this).attr("data-id")).hide();
//             }
//         })
//         $(this).toggleClass("open");
//         if($(this).hasClass("open")){
//             $(".faqs-type-"+id).show();
//         }else{
//             $(".faqs-type-"+id).hide();
//         }
        
//     }); 
  
   $(".quick-guide-content #sticky-sidebar .button").on("click",function(event){
  	$(this).closest("#sticky-sidebar").find(".button").removeClass("active");
    $(this).addClass("active")
  });
  
  if($(".product-faq-index").length > 0 && $(window).width() > 767){
  	$("html").css("scroll-padding-top", "118px");
  }
  
  
  $("custom-dropdown").on("click",function(){
    if($(this).hasClass("active")){
      $(this).removeClass("active")
       $(this).find(".dropdown-content2").slideUp()
    }
    else{
      $(this).find(".dropdown-content2").slideDown()
      $(this).addClass("active")
    }
  	
  
  });
  $("custom-dropdown .dropdown-content2 a").on("click",function(){
    $(this).closest("#MainContent").find(".faqs-opener").hide()
    $(this).closest("#MainContent").find(".faqs-wrapper").hide()
    var data = $(this).attr("data-id");
    $(this).closest("#MainContent").find(".faqs-opener[data-id='"+data+"']").show()
    $(this).closest("#MainContent").find(".faqs-wrapper.faqs-type-"+data+"").show()
  });
  
  $("custom-dropdown.measurement-dropdown .dropdown-content2 a").on("click",function(){
	$(this).closest(".measurement-dropdown").find(".dropbtn span").html($(this).attr("data-id"));
    var index = $(".measurement_blck.mobile .image_top_holder[data-title='"+$(this).attr("data-id")+"']").index();
    $(".measurement_blck.mobile .block_cover").flickity("select", index)
  });
  
  $(".menu-drawer__menu:not(.child--menu-list) .menu-drawer__menu-item:not(.child--menu-list-summary)").on("click",function(){
     $(".header .header__icon--menu").hide()
  })
   $(".menu-drawer__inner-submenu .menu-drawer__close-button").on("click",function(){
     $(".header .header__icon--menu").show()
  })
   
   $('.cross-promotion').click(function(){
    $('#promotion-banner').fadeOut();
  });
   
   
  
  $(".template-product .collection  .slider-desktop-gutter .slider-button").on("click",function(){
    var scroll_btn = $(this);
    setTimeout(function(){
    
    if($(scroll_btn).closest("slider-component").find(".slider").scrollLeft() > 0){
        	$(scroll_btn).closest(".slider-buttons").find(".slider-button--prev").attr("disabled",false)
            $(scroll_btn).closest(".slider-buttons").find(".slider-button--prev").addClass("show-visible")
    }
    else{
    	$(scroll_btn).closest(".slider-buttons").find(".slider-button--prev").attr("disabled",false)
            $(scroll_btn).closest(".slider-buttons").find(".slider-button--prev").removeClass("show-visible")
    }
      }, 700)
    if($(this).attr("name") == "next"){
    }
  });
  
  
  $(".product-color--swatches input").on("change", function(){
  	$(this).closest(".product-color--swatches").find(".selected__color").html($(this).val());
  });
 
  
  $("color-swatch ul.color-options li").on("click", function(){
  	$(this).siblings(".color_product").removeClass("active-color");
    $(this).addClass("active-color");
    
    var color_img = $(this).attr("data-color").toLowerCase();
    var alt_exist = false;
    var counter = 0;
    $(this).closest(".card-wrapper").find(".card__inner .image_thumb_none img").each(function(){
      if($(this).attr('data-alt')){
        if($(this).attr('data-alt').toLowerCase().includes(color_img)){
          alt_exist = true;
        }
      }
    });
    if(alt_exist == true){
      $(this).closest(".card-wrapper").find(".card__inner .media").html('');
      $(this).closest(".card-wrapper").find(".card__inner .image_thumb_none img").each(function(){
        if($(this).attr('data-alt').toLowerCase().includes(color_img)){
          alt_exist = true;
          counter = counter + 1;
          if(counter < 3){
            var clone = $(this).clone();
            $(this).closest(".card-wrapper").find(".card__inner .media").append(clone);
          }
        }
      });
      
    }
    
  });
  
  $(".size_popup").on("click", function(){
    $("#size_guide").addClass("six");
    $(".product_size .tab_inner").removeClass('active');
    $(".product_size #tab_1").addClass('active');
    $(".product_size .size-table-title").css("display","block");
  });
  
  
  $(document).on("click",".cart_bottom_holder .cart_quantity .adjust_qty",function(){
  		var qty = $(this).parent('.qty_box').find('input').val();
        if($(this).hasClass('minus')){
          if(qty > 1){
            qty = parseInt(qty) - 1; 
          }
        }else{
          qty = parseInt(qty) + 1;
        }
        var line = $(this).parent('.qty_box').find('input').data('line') ;
         var data = {id:line,quantity:qty}
         $.post('/cart/change.js',data,function(change){
          cartDrawer();
        },'json');
  });
  $(document).on("click",".cart_bottom_holder .remove_cart_drawer ",function(){
  		var qty = 0;
        var line = $(this).attr("data-line")
         var data = {id:line,quantity:qty}
         $.post('/cart/change.js',data,function(change){
          cartDrawer();
        },'json');
  });
    
     //TOGGLING NESTED ul
  $(document).on("click",".drop-down .selected a",function() {
         $(this).closest(".drop-down").find(".options ul").toggle();
    });

    //SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
    $(document).on("click",".drop-down .options ul li a",function() {
        var text = $(this).html();
        $(this).closest(".drop-down").find(".selected a span").html(text);
         $(this).closest(".drop-down").find(".options ul").hide();
    }); 

  $(document).on("click","quantity-dropdown.drop-down .options ul li a",function() {
        var qty = $(this).attr("data-value");
    var line = $(this).closest(".drop-down").attr("data-line")
         var data = {line:line,quantity:qty}
//          $.post('/cart/change.js',data,function(change){
//           window.location.reload();
//         },'json');
         var cart_items  = new CartItems();
        cart_items.updateQuantity(line,qty);
        setTimeout(function(){ 
           $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json', 
            success: function (cart) {
              console.log(cart.item_count);
//               $(".cart-top-wrapper .title-wrapper-with-link .p1_text").html(cart.item_count+" items")
//                 $(".cart-item[data-prod-name='prod-e5']").parent().prepend($(".cart-item[data-prod-name='prod-e5']"))
//                  cartDrawer2()
            }
          });
        }, 1000);
       
        
    }); 

    //HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
    $(document).bind('click', function(e) {
        var $clicked = $(e.target);
        if (! $clicked.parents().hasClass("drop-down"))
            $(".drop-down .options ul").hide();
    });
  
  
  $("#size_guide .table_top_holder .unit_tab .tab_parent").on("click", function(){
  	var tab = $(this).attr("data-id");
    $("#size_guide .table_top_holder .unit_tab .tab_parent").removeClass("active");
    $(this).addClass("active");
    $("#size_guide .size_table table td span").removeClass("activated");
    $("#size_guide .size_table table td span."+tab+"").addClass("activated");
  });
  
  $("#size_guide .table_top_holder .tabs_main:not(.unit_tab) .tab_parent").on("click", function(){
  	var tab = $(this).attr("data-id");
      $(this).siblings(".tab_parent").removeClass("active");
      $(this).addClass("active");
    $("#size_guide .desktop_size_table .size_table").removeClass("active");
     $("#size_guide .desktop_size_table .size_table[data-id='"+tab+"']").addClass("active");
  });
  
  
  
  $(document).on('click',' #size_guide .tab_container .tab_content .measurement a',function(e){
    console.log('clicked');
    $(this).parents('.tab_content').removeClass('active');
    $('.size-table-title.text-center').css('display','none');
    $(this).parents('.product_size').find('.measurement_blck').addClass('active');
    $("#size_guide .measurement_blck.mobile .block_cover").flickity({
          cellAlign: 'left',
          contain: true,
          autoPlay: false,
          pageDots: true,
          loop: true,
          wrapAround: true,
          pauseAutoPlayOnHover: false,
          prevNextButtons: false
      });

  })
  $("#size_guide .measurement_blck.mobile .block_cover").on( 'change.flickity', function( event, index ) {
    console.log(  $(this) )
    
    $(".measurement-dropdown .dropbtn span").html($($(this).find(".image_top_holder")[index]).attr("data-title").replace("_"," "));
  });
  
  $(".measurement_blck .tabs_measur").on("click", function(){
  	var tab = $(this).data("title")
  });
  
  $(document).on('click','.measurement_blck .size_guide',function(e){
  $(this).parents('.measurement_blck').removeClass('active');
  $(this).parents('.product_size').find('.tab_content').addClass('active');
  $('.size-table-title.text-center').css('display','block');
})
$(document).on('click',' #size_guide .measurement_blck .text_block .measurement_guide_tabs .tabs_cover .tabs_measur',function(e){
  var data_title = $(this).data('title');
  $(' #size_guide .measurement_blck .text_block .measurement_guide_tabs .tabs_cover .tabs_measur').removeClass('active');
  $(this).addClass('active');
  if( data_title.indexOf('Weight') > -1){
    $(' #size_guide .measurement_blck .text_block .measurement_guide_tabs .tabs_content .tab_single').removeClass('active');
    $(this).parents('.measurement_guide_tabs').find(".tabs_content .tab_single[data-title='Weight_(Lbs)']").addClass('active');
    $(' #size_guide .measurement_blck .block_cover .image_cover img').removeClass('active');
    $(' #size_guide .measurement_blck .block_cover .image_cover img[data-title="Weight_(Lbs)"]').addClass('active');
    $('.tabs_content').animate({ 
      scrollTop: $(this).parents('.measurement_guide_tabs').find(".tabs_content .tab_single[data-title='Weight_(Lbs)']").offset().top - 280
    },500);
  }else{
    $('#size_guide .measurement_blck .text_block .measurement_guide_tabs .tabs_content .tab_single').removeClass('active');
    $(this).parents('.measurement_guide_tabs').find(".tabs_content .tab_single[data-title="+data_title+"]").addClass('active');
    $(' #size_guide .measurement_blck .block_cover .image_cover img').removeClass('active');
    $(' #size_guide .measurement_blck .block_cover .image_cover img[data-title="'+data_title+'"]').addClass('active');
    if(data_title == "CHEST"){
      $('.tabs_content').animate({ 
      scrollTop: 0
    },500);
    }
    else{
    $('.tabs_content').animate({ 
      scrollTop: $(this).parents('.measurement_guide_tabs').find(".tabs_content .tab_single[data-title='"+data_title+"']").offset().top - 280
    },500);
    }
  }
  
})

$(document).on('touchend',' #size_guide .measurement_blck.mobile .block_cover .tabs_content .tab_single',function(e){
  var data_title = $(this).data('title');
  $(' #size_guide  .measurement_blck.mobile .block_cover .tabs_content .tab_single').removeClass('active_measurement');
  $(' #size_guide  .measurement_blck.mobile .block_cover .tabs_content .tab_single .text_cover').css('display',"none");
  $(this).addClass('active_measurement');
  $(this).find(".text_cover ").css("display","block");
    $(' #size_guide .measurement_blck.mobile .block_cover .image_top_holder .image_cover img').removeClass('active');
    $(' #size_guide .measurement_blck.mobile .block_cover .image_top_holder .image_cover img[data-title="'+data_title+'"]').addClass('active');
})
$(document).on('click',' #size_guide .measurement_blck.mobile .block_cover .tabs_content .tab_single',function(e){
  var data_title = $(this).data('title');
  $(' #size_guide  .measurement_blck.mobile .block_cover .tabs_content .tab_single').removeClass('active_measurement');
  $(' #size_guide  .measurement_blck.mobile .block_cover .tabs_content .tab_single .text_cover').css('display',"none");
  $(this).addClass('active_measurement');
  $(this).find(".text_cover ").css("display","block");
    $(' #size_guide .measurement_blck.mobile .block_cover .image_top_holder .image_cover img').removeClass('active');
    $(' #size_guide .measurement_blck.mobile .block_cover .image_top_holder .image_cover img[data-title="'+data_title+'"]').addClass('active');
})

  $(document).on('click',' .cover_wish_and_size a[href="#size_guide"]',function(e){
  	$($(' #size_guide .measurement_blck.mobile .block_cover .tabs_content .tab_single')[0]).click();
    $($(' #size_guide .measurement_blck .text_block .measurement_guide_tabs .tabs_cover .tabs_measur')[0]).click();
    console.log("TEST")
  });
  
  $(".localization-selector").on("click", function(){
    if($(this).hasClass("activated")){
    	$(this).removeClass("activated");
    }
    else{
      $(this).addClass("activated");
    
    }
    
//     if($(this).closest("#menu-drawer").length > 0){
//       var new_btn =  $(this).closest(".menu-drawer-container").find(".header__icon--menu");
//       var new_btn2 =  $(this).closest(".menu-drawer-container");
//       $(this).closest(".menu-drawer-container").addClass("menu-opening");
//       $(this).closest(".menu-drawer-container").attr("open",true);
//       setTimeout(function(){
//          $(new_btn).click();
//          $(new_btn2).addClass("menu-opening");
//           $(new_btn2).attr("open",true);
//         }, 400)
//     }
  })
  
  $(".size-cross").click(function(){
    $("modal-dialog").removeAttr("open");
    $('#size_guide').removeClass("six");
  });
  
});


// $(document).ready(function(){

// 		$(window).load(function(){
//           if($(".popup-wrap").length > 0){
//           var session_1  = sessionStorage.getItem("silver_pop");
//   	var expire = 0;
//     if(session_1 == undefined){
//            $("html, body").animate({ scrollTop: 0 }, 0);
// 			$('.popup-wrap').fadeIn(500);
//             if($(window).width() > 600){
//                   $("body").css("overflow","hidden");
//             }
//             sessionStorage.setItem("silver_pop", 1);
//     }
// 			$('.popup .btn--close').on("click",function(){
// 				$('.popup-wrap').fadeOut(500);
//                 $("body").css("overflow","unset");
// 			});
			
//           }
// 		});
// 	});
var modal_div = document.getElementsByClassName('modal-content-pro')[0];
document.addEventListener('click', function( event ) {
  if(typeof modal_div === "undefined") return;
  if (modal_div !== event.target && !modal_div.contains(event.target)) {    
    $('#promotion-banner').fadeOut();
  }
});